import { DOCTOR } from "@/data";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[#1A1C1A] text-[#c9c7c1] pt-20 pb-10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-10 border-b border-white/10 pb-14">
        <div className="md:col-span-5">
          <p className="font-serif-display text-3xl text-[#FDFBF7]">Dr. Pranidha Shree C A</p>
          <p className="mt-1 text-sm text-[#E8A87C]">{DOCTOR.quals}</p>
          <p className="mt-5 text-sm leading-relaxed max-w-sm">
            Consultant Gynecologic Oncologist dedicated to compassionate, precise and
            evidence-based cancer care for women.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-[#9d9b96] mb-4">Explore</p>
          <ul className="space-y-2 text-sm">
            {[["About", "#about"], ["Expertise", "#expertise"], ["Cancers", "#cancers"], ["Research", "#research"], ["Reviews", "#reviews"], ["Book", "#appointment"]].map(([l, h]) => (
              <li key={h}><a href={h} className="hover:text-[#E8A87C] transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline text-[#9d9b96] mb-4">Contact</p>
          <ul className="space-y-3 text-sm">
            <li><a href={`tel:+${DOCTOR.phoneIntl}`} className="flex items-center gap-3 hover:text-[#E8A87C] transition-colors"><Phone size={15} /> {DOCTOR.phone}</a></li>
            <li><a href={`https://wa.me/${DOCTOR.phoneIntl}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[#E8A87C] transition-colors"><MessageCircle size={15} /> WhatsApp</a></li>
            <li><a href={`mailto:${DOCTOR.email}`} className="flex items-center gap-3 hover:text-[#E8A87C] transition-colors break-all"><Mail size={15} /> {DOCTOR.email}</a></li>
            <li className="flex items-start gap-3"><MapPin size={15} className="mt-0.5" /> {DOCTOR.hospital}</li>
          </ul>
        </div>
      </div>

      <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#9d9b96]">
        <p>© {new Date().getFullYear()} Dr. Pranidha Shree C A. All rights reserved.</p>
        <p>Educational information only — not a substitute for professional medical advice.</p>
      </div>
    </div>
  </footer>
);
